import {
  postV1BillingCheckoutSessions,
  postV1BillingPortalSessions,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import connection from '~services/connectionModule';
import { useStores } from '~store';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

import { BillingSession } from './models';

export default function useBilling() {
  const { userStore } = useStores();
  const companyId = getEffectiveUserCompanyId(userStore);

  const createCheckoutSession = useCallback(async () => {
    try {
      const response = await postV1BillingCheckoutSessions({
        headers: { 'Idempotency-Key': crypto.randomUUID() },
        path: { 'company-id': companyId },
      });

      return BillingSession.parse(response.data.data);
    } catch (error) {
      try {
        connection.handleRequestError(
          error,
          t('error_messages.billing.failed_to_start_bank_setup'),
        );
      } catch {
        // Error handling side effects already executed in connection.handleRequestError.
      }

      return null;
    }
  }, [companyId]);

  const createPortalSession = useCallback(async () => {
    try {
      const response = await postV1BillingPortalSessions({
        headers: { 'Idempotency-Key': crypto.randomUUID() },
        path: { 'company-id': companyId },
      });

      return BillingSession.parse(response.data.data);
    } catch (error) {
      try {
        connection.handleRequestError(
          error,
          t('error_messages.billing.failed_to_open_billing_portal'),
        );
      } catch {
        // Error handling side effects already executed in connection.handleRequestError.
      }

      return null;
    }
  }, [companyId]);

  return { createCheckoutSession, createPortalSession };
}
